import { Link } from "react-router-dom";

const COLUMNS = [
    {
        title: "LUXATI",
        links: [
            { to: "/about", label: "About" },
            { to: "/opportunities", label: "Opportunities" },
            { to: "/technology", label: "Technology" },
            { to: "/for-investors", label: "Investors" },
            { to: "/for-partners", label: "Partners" },
            { to: "/contact", label: "Contact" },
        ],
    },
    {
        title: "Legal",
        links: [
            { to: "/privacy", label: "Privacy Policy" },
            { to: "/terms", label: "Terms of Use" },
        ],
    },
];

export const Footer = () => (
    <footer data-testid="site-footer" className="grain-overlay bg-charcoal text-ivory">
        <div className="mx-auto max-w-[1400px] px-6 py-20 md:px-12 md:py-28">
            <div className="grid gap-16 md:grid-cols-12">
                <div className="md:col-span-6">
                    <p className="font-serif text-4xl font-medium tracking-[0.22em]">LUXATI</p>
                    <p className="mt-4 text-[11px] uppercase tracking-[0.3em] text-gold">
                        Real Estate Investments &amp; Partnerships
                    </p>
                    <p className="mt-8 max-w-sm text-sm font-light leading-relaxed text-ivory/60">
                        A modern real estate investment and advisory platform helping buyers and investors
                        discover, evaluate and connect with carefully selected opportunities.
                    </p>
                    <p className="mt-8 text-[11px] uppercase tracking-[0.3em] text-ivory/40">
                        India &bull; Dubai
                    </p>
                </div>
                {COLUMNS.map((col) => (
                    <div key={col.title} className="md:col-span-3">
                        <p className="text-[11px] font-medium uppercase tracking-[0.3em] text-ivory/40">{col.title}</p>
                        <ul className="mt-6 space-y-3">
                            {col.links.map((l) => (
                                <li key={l.to}>
                                    <Link
                                        to={l.to}
                                        data-testid={`footer-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                                        className="link-underline text-sm font-light text-ivory/75 transition-colors duration-300 hover:text-gold"
                                    >
                                        {l.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
            <div className="mt-20 border-t border-ivory/10 pt-8">
                <p className="max-w-3xl text-[11px] leading-relaxed text-ivory/40">
                    Information on this website is for general informational purposes and may change.
                    Project details, availability and pricing should be independently verified before
                    making a property decision.
                </p>
                <div className="mt-6 flex flex-col gap-3 text-[11px] text-ivory/40 md:flex-row md:items-center md:justify-between">
                    <p>
                        &copy; {new Date().getFullYear()} LUXATI. LUXATI is a real estate investment and advisory
                        vertical of Ibizo Technologies Private Limited.
                    </p>
                    <p className="uppercase tracking-[0.25em]">Understand &bull; Discover &bull; Evaluate &bull; Connect</p>
                </div>
            </div>
        </div>
    </footer>
);
